import { AxiosResponse } from "axios";
import { axiosConfigV2 } from "../../../config/api/configApiv2";

export const getAllUniversityApprove: (data: any) => Promise<AxiosResponse<any>> = (data) => {
    return axiosConfigV2.post(`question-bank/censor/get-all-facility-approve`, data)
}

export const getAllUniversityToMinisterialApprove: (data: any) => Promise<AxiosResponse<any>> = (data) => {
    return axiosConfigV2.post(`question-bank/censor/get-all-facility-to-ministerial-approve`, data)
}